import React, { Component } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import {
  setCookie,
  getCookie,
  eraseCookie,
  setLocalStorage,
  getLocalStorage,
  getUrlParam,
} from "../global/browserFunctions";
import products from "../data/products-clothes.json";
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Jumbotron, Pagination, PaginationItem, PaginationLink
} from "reactstrap";
import EachItem from "../components/EachItem";
import Icon from "../components/Icon";
import { searchUrl } from "../global/url";
import jquery from "jquery";
import Loader from "../components/Loader";
import { showNotification } from "../global/notification";

class Search extends Component {
  constructor(props) {
    super(props);
    if (!getCookie("log")) {
      // if not logged in, go to login page
      this.GoToPage("/");
    }
    var pageNum = getUrlParam("page") ? Number(getUrlParam("page")) : 1; //Get current page number
    this.PAGE_SIZE = 8; // ITEMS PER PAGE
    this.state = {
      query: "",
      hasItems: false,
      currentPage: pageNum - 1,
      items: [],
      pagedData: [],
      loading: true

    };
  }

  GoToPage(path) {
    this.props.history.push(path);
  }

  componentDidMount() {
    var query = getUrlParam("query");
    if (query) {
      this.setState({ query: query }, function () {
        this.setPageData();
      });

    }
  }



  async setPageData() {
    var pagedData = [];
    var pageNum = getUrlParam("page") ? Number(getUrlParam("page")) : 1; //Get page number from url param else 1
    var itemsPaginated = [];
    var items = await this.fetchItems();
    this.setState({ loading: false })
    if (items.length > 0) {
      pagedData =
          Array.isArray(items) && items.length
              ? this.chunkArray(items, this.PAGE_SIZE) //Set 8 items per page
              : [];

      this.setState({ pagedData: pagedData });
      itemsPaginated = pagedData[pageNum - 1] || [];
      this.setState({ items: itemsPaginated }, function () {
        this.setState({ loading: false })
      });
      this.setState({ hasItems: true })
    }


  }

   fetchItems() {
    var self = this;
    var currency = getCookie("currency");
    var pricelevel = getCookie("pricelevel") || "5";
    var location = getCookie("location") || "1";
    var id = getCookie("customid");
    var cur = 'USD';
    if(currency === 1){
      cur = 'USD'
    }else if(currency === 3){
      cur = 'CAD'
    }
    if (this.state.query != "") {
      var q = "&query=" + encodeURIComponent(this.state.query) + "&priceLevel=" + pricelevel + "&location=" + location + "&currency=" + currency + "&customerid=" + id;
      try {
        if (window.CategoryDetails[cur]) {
          var items = [];
          var bicycleItems = window.CategoryDetails[cur][12770].items;
          var query = this.state.query.toLowerCase();
          //Searching in Bicycle items
          bicycleItems.forEach(item =>{
            var flag = false;
            //Searching in child items
            if(item.child_items){
              for (const key in item.child_items){
                let vendorName = item.child_items[key].item_vendorname.value.toLowerCase();
                let displayName = item.child_items[key].item_displayname.value.toLowerCase();
                let storeDescription = item.child_items[key].item_storedescription.value.toLowerCase();
                let itemName = item.child_items[key].item_itemid.value.toLowerCase();
                if(vendorName.includes(query) || displayName.includes(query) || storeDescription.includes(query) || itemName.includes(query)){
                  flag = true;
                }
              }
            }
            //Searching in parent item
            let vendorName = item.item_vendorname.value.toLowerCase();
            let displayName = item.item_displayname.value.toLowerCase();
            let storeDescription = item.item_storedescription.value.toLowerCase();
            let itemName = item.item_itemid.value.toLowerCase();
            if(flag || vendorName.includes(query) || displayName.includes(query) || storeDescription.includes(query) || itemName.includes(query)){
              items.push(item);
            }
          });
          //Searching in Accessories
          var accessoriesItems = window.CategoryDetails[cur][12771].items;
          accessoriesItems.forEach(item =>{
            var flag = false;
            //Searching in child items
            if(item.child_items){
              for (const key in item.child_items){
                let vendorName = item.child_items[key].item_vendorname.value.toLowerCase();
                let displayName = item.child_items[key].item_displayname.value.toLowerCase();
                let storeDescription = item.child_items[key].item_storedescription.value.toLowerCase();
                let itemName = item.child_items[key].item_itemid.value.toLowerCase();
                if(vendorName.includes(query) || displayName.includes(query) || storeDescription.includes(query) ||  itemName.includes(query)){
                  flag = true;
                }
              }
            }
            //Searching in parent item
            let vendorName = item.item_vendorname.value.toLowerCase();
            let displayName = item.item_displayname.value.toLowerCase();
            let storeDescription = item.item_storedescription.value.toLowerCase();
            let itemName = item.item_itemid.value.toLowerCase();
            if(flag || vendorName.includes(query) || displayName.includes(query) || storeDescription.includes(query) || itemName.includes(query)){
              items.push(item);
            }
          });
          return items;
        }
      } catch (error) {
        showNotification(
            "Sorry",
            "danger",
            "An unknown error occured. Please try again later"
        );
        return [];
      }
    }
    else
      return [];

  }

  chunkArray(array, size) {
    //Chunk array for pagination
    const chunked_arr = [];
    let copied = [...array]; // ES6 destructuring
    const numOfChild = Math.ceil(copied.length / size); // Round up to the nearest integer
    for (let i = 0; i < numOfChild; i++) {
      chunked_arr.push(copied.splice(0, size));
    }

    return chunked_arr;
  }

  handleClick(e, index) {
    //Function that triggers pagination
    e.preventDefault();
    if (index >= 0 && index <= this.state.pagedData.length - 1) {
      this.setState({ currentPage: index });
      this.setState({ items: this.state.pagedData[index] });
      //this.myRef.current.scrollIntoView();
      window.scrollTo(0, 0);
      var search = getUrlParam("query");

      // var query= '?'+filters!=null?"filters="+filters+'&page=' + ++index : 'page=' + ++index;
      // query+=filters!=null? sort!=null?'&sort='+sort:'sort='+sort +'&page=' + ++index : 'page=' + ++index;

      var query = "?";
      query += "query=" + search;
      query += "&page=" + ++index;

      this.props.history.push({
        pathname: "/search",
        search: query,
      });
    }
  }

  render() {
    return (
        <React.Fragment>
          <Loader loading={this.state.loading} />
          <Header
              headermenu={this.headermenu}
              history={this.props.history}
              searchquery={this.state.query}
          />
          <section className="hero py-6">
            <Container>
              <Breadcrumb className="pl-0">
                <BreadcrumbItem>
                  <a href="/home">Home</a>
                </BreadcrumbItem>
                <BreadcrumbItem active>Search</BreadcrumbItem>
              </Breadcrumb>
              <div className="hero-content">
                <h2 className="hero-heading mb-3">
                  Search results for{" "}
                  <span className="text-primary">{this.state.query}</span>
                </h2>
              </div>
              {this.state.hasItems && (
                  <Row className="mt-7">
                    {this.state.items.map((product, index) => (
                        <Col key={index} sm="4" xl="3" xs="6">
                          <EachItem product={product} />
                        </Col>
                    ))}
                  </Row>
              )}
              {!this.state.hasItems && (
                  <div>
                    <Jumbotron fluid>
                      <Container fluid>
                        <p className="lead">No Items Found</p>
                      </Container>
                    </Jumbotron>
                  </div>
              )}
              <div className="pagination-wrapper">
                {this.state.hasItems && (
                    <Pagination className="d-flex justify-content-center mb-5 mt-3">
                      <PaginationItem
                          className="page-arrow"
                          disabled={this.state.currentPage <= 0}
                          onClick={(e) =>
                              this.handleClick(e, this.state.currentPage - 1)
                          }
                      >
                    <span className="page-arrow" href="#">
                      <span aria-hidden="true">
                        <Icon icon="angle-left-1" className="page-icon" />
                      </span>

                      <PaginationLink
                          className="sr-only"
                          onClick={(e) =>
                              this.handleClick(e, this.state.currentPage - 1)
                          }
                          previous
                          href="#"
                      />
                      <span className="sr-only">Previous</span>
                    </span>
                      </PaginationItem>

                      {this.state.pagedData.map((page, i) => (
                          <PaginationItem
                              active={i === this.state.currentPage}
                              key={i}
                          >
                            <PaginationLink
                                onClick={(e) => this.handleClick(e, i)}
                                href="#"
                            >
                              {i + 1}
                            </PaginationLink>
                          </PaginationItem>
                      ))}

                      <PaginationItem
                          className="page-arrow"
                          disabled={
                            this.state.currentPage >=
                            this.state.pagedData.length - 1
                          }
                          onClick={(e) =>
                              this.handleClick(e, this.state.currentPage + 1)
                          }
                      >
                    <span className="page-arrow" href="#">
                      <span aria-hidden="true">
                        <Icon icon="angle-right-1" className="page-icon" />
                      </span>
                      <PaginationLink
                          className="sr-only"
                          onClick={(e) =>
                              this.handleClick(e, this.state.currentPage + 1)
                          }
                          next
                          href="#"
                      />
                      <span className="sr-only">Next</span>
                    </span>
                      </PaginationItem>
                    </Pagination>
                )}
              </div>

            </Container>
          </section>
          <Footer />
        </React.Fragment>
    );
  }
}

export default Search;

